interface LoaderProps {
  size?: number;
}

export const Loader = ({size = 16}: LoaderProps) => (
  // <Loader2 className="shrink-0 animate-spin" style={{width: size, height: size}} />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{width: size, height: size}}
    className="shrink-0 animate-spin"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);
